var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  CardGroup: () => CardGroup
});
var import_cardManager = __toModule(require("./cardManager"));
class CardGroup {
  constructor(samaData, samaForm, cardGroupForm, addScreenId, filter) {
    this.samaData = samaData;
    this.samaForm = samaForm;
    this.cardGroupForm = cardGroupForm;
    this.addScreenId = addScreenId;
    this.filter = filter;
    this.cardManager = new import_cardManager.CardManager(samaData, samaForm, cardGroupForm, addScreenId, filter);
  }
  getEditScreenId() {
    return this.cardGroupForm.editScreenId;
  }
  getYayoyakis(index) {
    return this.cardManager.getYayoyakis(index);
  }
  getYayoyakisSiblingsId() {
    return this.cardManager.getYayoyakisSiblingsId();
  }
  add(navigationIndex) {
    return this.cardManager.add(navigationIndex);
  }
  delete(card) {
    this.cardManager.delete(card);
  }
  deleteEmptyCards() {
    this.cardManager.deleteEmptyCards();
  }
  deleteAll() {
    this.cardManager.deleteAll();
  }
  edit(card) {
    return this.cardManager.edit(card);
  }
  list() {
    return this.cardManager.list();
  }
  validate(card) {
    return this.cardManager.validate(card);
  }
  getCard(index) {
    return this.cardManager.get(index);
  }
  isReadOnly() {
    return !!this.cardGroupForm.readOnly;
  }
  getId() {
    return this.cardGroupForm.id;
  }
  getRenderForm() {
    return {
      cardId: this.cardGroupForm.cardId,
      warningModalTitle: this.cardGroupForm.warningModalTitle,
      warningModalContent: this.cardGroupForm.warningModalContent,
      title: this.cardGroupForm.title
    };
  }
  isPendingReview() {
    return this.list().filter((card) => card.isReviewable() && !card.isReviewed()).length > 0;
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  CardGroup
});
